var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('f7-button',{staticClass:"boton-eliminar-materiales",staticStyle:{"max-width":"109px"},attrs:{"type":"default","styling-mode":"contained","name":"ButtonMaterialRequest"},on:{"click":_vm.deleteMaterials}},[_vm._v("\n    "+_vm._s(_vm.$t('deleteAll'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }